import type { RotationOffsets } from '../types';
import apiRequest from './apiRequest';

export type BatchStatus =
  | 'VALIDATING'
  | 'QUEUED'
  | 'IN_PROGRESS'
  | 'COMPLETED'
  | 'REJECTED'
  | 'CANCELLED'
  | 'FAILED';

export type BatchExportSettings = {
  characterID: string;
  exportType: string;
  forward: string;
  up: string;
  frameRate: number;
  frameStepSize: number;
  moveInPlace: string;
  includeMesh: string;
  keyframeCleaning: string;
  faceExpression: string;
  handID: string;
  ikFeet: string;
  ikHands: string;
  rotationOffsets: RotationOffsets;
  skeletonTemplate: string;
  trimValues: string;
  skinHex: string;
};

export type BatchModel = 'SCOOT' | 'SWING' | 'COMIC';

export type BatchResponse = {
  batchID: string;
  batchName: string;
  status: BatchStatus;
  type: 'COMIC' | 'GENERATION' | 'MASCOT';
  emailSubscribers: string[];
  exportSettings: BatchExportSettings;
  model?: BatchModel;
  /** Requested duration of each motion in seconds. Only present on swing motions. */
  requestedDuration?: number;
  numTotalJobs: number;
  estimatedSecondsWaitTime: number;
  downloadURL: string | null;
  /** Presigned thumbnail for the most recent job in the batch, when available. */
  thumbnailURL?: string | null;
  createdAt: string;
  createdBy: string;
  /** Cartwheel user ID of the creator, when available. */
  createdByUser?: string;
};

export default async function getBatch(batchID: string, apiKey: string) {
  return await apiRequest<BatchResponse>(
    'external-mogen',
    `/batch/${batchID}`,
    {
      method: 'GET',
      headers: {
        'x-api-key': apiKey,
      },
    },
  );
}
